<template lang="html">
  <div
    :class="{'cursor-pointer': !disabled, 'cursor-not-allowed': disabled}"
    style=""
  >
    <div
      v-if="hasActivator"
      @click="pickFile"
    >
      <slot name="activator" />
    </div>
    <!-- <div v-if="!hasActivator" slot="activator" class="cursor-not-allowed">
      <v-btn :color="buttonColor" @click.native.stop="pickFile" :disabled="disabled">
        <v-icon class="mr-2">add</v-icon> Add
      </v-btn>
    </div> -->
    <input
      ref="upload"
      type="file"
      name="image"
      :accept="accept"
      :multiple="multiple"
      @change="filePicked"
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb, storage } from '@/plugins/firebase'
import { forEach } from 'lodash'
import uniqid from 'uniqid'

export default {
  props: {
    registerPath: {
      type: String
    },
    savePath: {
      type: String
      // required: true
    },
    multiple: Boolean,
    accept: {
      type: String,
      default: ''
    },
    buttonColor: {
      default: 'primary'
    },
    disabled: Boolean,
    disableUpload: Boolean
  },
  data () {
    return {
      fileUploadfileUploades: {}
    }
  },
  computed: {
    ...mapGetters(['_fileUploads']),
    hasActivator () {
      return !!this.$slots.activator
    },
    storageUrl () {
      return process.env.VUE_APP_STORAGE_URL
    }
  },
  mounted () {
    if (!this.disableUpload && !this.savePath) throw new Error('[Si Warn]: Missing required prop: "savePath". \n\n Requires valid path as string unless "disableUpload" = true.')
  },
  methods: {
    resetInput () {
      const input = this.$refs.upload
      input.type = 'text'
      input.type = 'file'
    },
    pickFile () {
      if (!this.disabled) this.$refs.upload.click()
    },
    filePicked (event) {
      // input change event - check a file has been added then call the editor
      const files = event.target.files || event.dataTransfer.files
      if (files && files[0]) {
        forEach(files, file => {
          this.uploadFile(file)
        })
      }
      this.resetInput()
    },
    uploadFile (file) {
      let filename = file.name
      if (filename && filename.lastIndexOf('.') <= 0) return
      let name = filename.split('.')[0]
      let extension = filename.split('.')[1]
      let fileId = uniqid()
      let fileIdName = `${fileId}.${extension}`
      var registerPath = `${this.registerPath}/${fileId}`
      var storagePath = `${this.savePath}/${fileIdName}`
      var fileUpload

      var details = {
        id: fileId,
        name: name,
        title: name,
        extension: extension,
        size: file.size,
        storagePath: storagePath,
        path: `${this.storageUrl}/${fileIdName}`,
        type: file.type
      }

      if (this.disableUpload) {
        fileUpload = Object.assign({}, details, { file: file }, { state: 'complete', progress: 100, bytesTransferred: file.size })
        this.$emit('update', fileUpload, details)
        return
      }

      const uploadTask = storage.ref().child(storagePath).put(file)

      fileUpload = Object.assign({}, details, { uploadTask }, { state: 'running', progress: 0, bytesTransferred: 0 })

      this.$emit('update', fileUpload, details)

      uploadTask.on('state_changed', s => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        fileUpload.progress = s.totalBytes ? (s.bytesTransferred / s.totalBytes) * 100 : 100
        fileUpload.bytesTransferred = s.bytesTransferred
        fileUpload.state = s.state
        console.log('Upload is ' + (s.bytesTransferred / s.totalBytes) * 100 + '% done')

        this.$emit('update', fileUpload, details)
      }, error => {
        console.error(error);
        // Handle unsuccessful uploads
        if (error.code === 'storage/canceled') {
          fileUpload.state = 'canceled'

          this.$emit('update', fileUpload, details)
        } else {
          fileUpload.state = 'error'

          this.$emit('update', fileUpload, details)

          console.error(error)
        }
      }, () => {
        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          details.downloadURL = downloadURL
          fileUpload.state = 'complete'
          fileUpload.downloadURL = downloadURL

          if (this.registerPath) {
            rtdb.ref(registerPath).set(details).then(() => {
              this.$emit('update', fileUpload, details)
            })
          } else {
            this.$emit('update', fileUpload, details)
          }
        })
      })
    },
    uploadCancel () {
      // this.resetInput()
    }
  }
}
</script>

<style scoped>
input[type=file] {
    position: absolute;
    left: -99999px;
    opacity:0;
    height:0px;
    width:0px;
}

</style>
